import React, { useState, useEffect } from 'react';
import { admin as adminApi } from '../utils/api';
import { useApp } from '../context/AppContext';
import toast from 'react-hot-toast';

import { useNavigate } from 'react-router-dom';

export default function AdminConfig() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [values,  setValues]  = useState({});

  useEffect(() => {
    adminApi.getConfig()
      .then(res => {
        setConfigs(res.configs || []);
        const v = {};
        res.configs?.forEach(c => { v[c.config_key] = c.config_value; });
        setValues(v);
      })
      .catch(() => toast.error('Failed to load configuration'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (key, val) => {
    setValues(prev => ({ ...prev, [key]: val }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminApi.updateConfig({ configs: values });
      toast.success('Configuration updated successfully!');
    } catch (err) {
      toast.error(err.error || 'Failed to update configuration');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="page-loader"><div className="spinner" /></div>;

  const TABS = [
    ['overview', 'Overview', '📊'],
    ['moderators', 'Moderators', '🛡️'],
    ['users', 'Users', '👥'],
    ['locations', 'Locations', '📍'],
    ['traffic', 'Traffic', '📈']
  ];

  return (
    <div className="dashboard-layout">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-menu">
          <div className="section-title hide-mobile" style={{ fontSize: '11px', marginBottom: '8px' }}>Admin Menu</div>
          {TABS.map(([k, label, icon]) => (
            <button key={k} onClick={() => navigate('/admin')}
              className="sidebar-link">
              <span style={{ fontSize: '16px' }}>{icon}</span>
              <span>{label}</span>
            </button>
          ))}
        </div>

        <div className="sidebar-footer">
          <button 
            className="sidebar-link" 
            style={{ padding: '8px 0', width: '100%', justifyContent: 'flex-start' }}
            onClick={() => navigate('/admin')}
          >
            <span style={{ fontSize: '16px' }}>⬅️</span>
            <span>Back to Admin</span>
          </button>
          <button 
            className="sidebar-link active" 
            style={{ padding: '8px 0', width: '100%', justifyContent: 'flex-start' }}
          >
            <span style={{ fontSize: '16px' }}>⚙️</span>
            <span>{t('platform_config')}</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content fade-in">
        <div style={{ maxWidth: '800px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 700 }}>⚙️ {t('platform_config')}</h1>
          </div>

          <form className="card" onSubmit={handleSubmit}>
            <p style={{ fontSize: '14px', color: 'var(--text3)', marginBottom: '20px' }}>
              Adjust system-wide settings, token costs, and platform parameters.
            </p>

            {configs.length === 0 ? (
              <div className="empty-state">No configuration keys found in database.</div>
            ) : (
              configs.map(cfg => (
                <div key={cfg.config_key} className="form-group">
                  <label className="form-label" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>{cfg.config_key.replace(/_/g, ' ')}</span>
                    <code style={{ fontSize: '10px', opacity: 0.6 }}>{cfg.config_key}</code>
                  </label>
                  <input
                    className="form-input"
                    value={values[cfg.config_key] || ''}
                    onChange={(e) => handleChange(cfg.config_key, e.target.value)}
                    placeholder="Value"
                  />
                  {cfg.description && (
                    <small style={{ display: 'block', marginTop: '4px', fontSize: '11px', color: 'var(--text3)' }}>
                      {cfg.description}
                    </small>
                  )}
                </div>
              ))
            )}

            <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
              <button type="submit" className="btn btn-primary" disabled={saving || configs.length === 0}>
                {saving ? <span className="spinner" style={{ width: 16, height: 16 }} /> : 'Save All Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
